<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="プライベートゾーン設定(Type1、イントラネットFW)"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-3">
              <v-col class="d-flex flex-row ga-2 justify-end">
                <v-btn color="primary" @click="toAddZone"> 追加 </v-btn>
                <v-btn color="primary" @click="toDelete"> 削除 </v-btn>
              </v-col>
            </v-row>
            <v-alert v-model="showAlert" class="my-2">{{
              $filter.message("no_select_data")
            }}</v-alert>
            <app-table
              primary-key="zoneId"
              v-model:table-sort-by="zoneList.sortBy"
              :fields="zoneList.fields"
              :items="zoneList.items"
              :hover="true"
              :selectable="true"
              :per-page="-1"
              v-model="zoneList.selected"
              @click:row="zoneSelected"
            >
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { Type1PrivateZoneDelete, Type1Zone } from "@/apis/Type1SiteApi";
import ZoneEdit from "@/modals/type1/ZoneEdit.vue";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";

export default defineComponent({
  name: "PrivateZoneList",
  props: {
    privateZone: {
      type: Array as PropType<Type1Zone[]>,
      required: true,
    },
    /** 排他確認用パラメータ */
    type1SiteZoneKeyId: {
      type: String,
    },
  },
  data() {
    return {
      showAlert: false as boolean,
      zoneList: {
        sortBy: {
          key: "zoneName",
          order: "asc",
        } as SortItem,
        fields: [
          {
            key: "zoneName",
            title: "ゾーン名",
          },
        ] as AppTableHeader<Type1Zone>[],
        items: [] as Type1Zone[],
        selected: [],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.zoneList.items = this.privateZone;
    },
    /** 追加機能 */
    async toAddZone() {
      this.showAlert = false;
      await this.$modal.show(ZoneEdit, {
        zoneMode: "privateRegister",
        type1SiteZoneKeyId: this.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 行選択機能 */
    async zoneSelected(item: Type1Zone) {
      this.showAlert = false;
      await this.$modal.show(ZoneEdit, {
        zoneMode: "privateModify",
        zoneDate: item,
        type1SiteZoneKeyId: this.type1SiteZoneKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 削除機能 */
    async toDelete() {
      this.showAlert = this.zoneList.selected.length === 0;
      if (this.showAlert) return;

      await this.$confirm(
        `プライベートゾーンを${this.zoneList.selected.length}件削除します。よろしいですか？`
      );

      const reqData: Type1PrivateZoneDelete = {
        zoneIdList: this.zoneList.selected.map((e: Type1Zone) => {
          return e.zoneId;
        }),
        type1SiteZoneKeyId: this.type1SiteZoneKeyId!,
      };
      await this.$api.type1SiteZone.postType1PrivateZoneDelete(reqData);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
